<template>
<svg
    class="svgClone"
    @click="clicked"
    @mouseout="mouseover"
    @mouseleave="mouseleave"
    @mouseenter="mouseenter"
    @mousedown="mousedown"
     width="18" height="20"  viewBox="0 0 460 460" fill="none" xmlns="http://www.w3.org/2000/svg">
  
  
    <path d="M425.934,0H171.662c-18.122,0-32.864,14.743-32.864,32.864v77.134h30V32.864c0-1.579,1.285-2.864,2.864-2.864h254.272
    c1.579,0,2.864,1.285,2.864,2.864v254.272c0,1.58-1.285,2.865-2.864,2.865h-74.729v30h74.729
    c18.121,0,32.864-14.743,32.864-32.865V32.864C458.797,14.743,444.055,0,425.934,0z" fill="black" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M288.339,139.998H34.068c-18.122,0-32.865,14.743-32.865,32.865v254.272C1.204,445.257,15.946,460,34.068,460h254.272
    c18.122,0,32.865-14.743,32.865-32.864V172.863C321.206,154.741,306.461,139.998,288.339,139.998z M288.341,430H34.068
    c-1.58,0-2.865-1.285-2.865-2.864V172.863c0-1.58,1.285-2.865,2.865-2.865h254.272c1.58,0,2.865,1.285,2.865,2.865v254.273h0.001
    C291.206,428.715,289.92,430,288.341,430z" fill="black" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
</svg>
</template>
<script>
export default {
    props:["color"],
    methods: {
        clicked() {
            this.$emit('clicked')
        },
        mouseover() {
            this.$emit('mouseover')
        },
        mouseleave() {
            this.$emit('mouseleave')
        },
        mousedown() {
            this.$emit('mousedown')
        },
        mouseenter() {
            this.$emit('mouseenter')
        },
    }
}
</script>
<style >

.svgClone:hover path {
    fill:#EF2035;
    stroke-width:2; 
}
.svgClone:hover circle {
    stroke:#EF2035;
    stroke-width:6;
    cursor:pointer;
}
</style>